import { SETTINGS_RECEIVED, SETTINGS_UNLOADED } from './types'

export default function settings(state = {}, action = {}){
  switch (action.type) {
    case SETTINGS_RECEIVED:
      return action.data
    case SETTINGS_UNLOADED:
      return []
    default:
      return state;
  }
}
